import Link from 'next/link';
import { getLifecycleBadge } from '@/utils/product-lifecycle';

type Props = {
  item: any;
  localeKey: string;
  href: string;
  onClick?: () => void;
  imgClassName?: string;
};

const BundleProductImage = ({ item, localeKey, href, onClick, imgClassName = 'h-20 w-20 object-contain' }: Props) => {
  const badge = getLifecycleBadge(item?.Lifecycle?.[localeKey]);

  return (
    <Link href={href} className="relative flex-shrink-0 block">
      {badge && (
        <div
          className="absolute left-0 top-0 z-10 rounded-[6px] px-1.5 py-0.5 text-[6px] font-semibold uppercase text-white shadow-sm"
          style={{ backgroundColor: badge.color }}
        >
          {badge.label}
        </div>
      )}
      <img
        src={item?.Images?.[0]?.url || '/images/No_product_Image.jpg'}
        alt={item?.name}
        className={imgClassName}
        onClick={onClick}
      />
    </Link>
  );
};

export default BundleProductImage;
